module.exports = __webpack_public_path__ + "img/banner-no-bg.3f4d798a.webp";